import { render, staticRenderFns } from "./optimiserAllocationList.vue?vue&type=template&id=507c044c&"
import script from "./optimiserAllocationList.vue?vue&type=script&lang=js&"
export * from "./optimiserAllocationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports